<template>
  <div>
    <el-drawer
      :title="supplierName + ' - 设备分类配置'"
      :visible.sync="drawerVisible"
      direction="rtl"
      size="60%"
      :before-close="handleClose"
    >
      <div class="tree-class-container">
        <div
          class="tree-content"
          style="height: calc(100vh - 150px); overflow-y: auto; padding: 20px"
        >
          <el-form
            ref="form"
            :model="form"
            label-width="120px"
            label-position="left"
          >
            <el-form-item label="供应商名称">
              <el-input v-model="supplierName" disabled></el-input>
            </el-form-item>

            <el-form-item label="设备分类" required v-loading="treeLoading">
              <div class="tree-tip">
                <i class="el-icon-info"></i>
                <span>请选择该供应商负责的设备分类</span>
                <el-button
                  type="text"
                  style="margin-left: 10px"
                  @click="getTreeData(true)"
                  >刷新</el-button
                >
              </div>
              <el-tree
                :data="TreeData"
                show-checkbox
                node-key="id"
               
                :props="defaultProps"
                ref="tree"
                @check-change="handleCheckChange"
              >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span
                    v-if="data.children && data.children.length > 0"
                    style="
                      font-weight: 1000;
                      font-size: 16px;
                      color: #000;
                      display: flex;
                      width: 50%;
                      align-items: center;
                      justify-content: space-between;
                    "
                  >
                    <span>
                      <i class="el-icon-s-grid" style="font-size: 18px"></i
                      >&nbsp;{{ node.label }}</span
                    >
                    <span
                      v-if="!data.flag && data.Level > 2"
                      style="display: flex; align-items: center"
                    >
                      <el-tag
                        style="font-size: 10px; float: right"
                        type="warning"
                        >无模板</el-tag
                      >
                      <el-button
                        type="text"
                        style="margin-left: 10px; font-size: 10px"
                        @click="handleEdit(data)"
                        >去配置</el-button
                      >
                    </span>
                  </span>
                  <span
                    v-if="!data.children"
                    style="
                      color: #000;
                      display: flex;
                      width: 50%;
                      align-items: center;
                      justify-content: space-between;
                    "
                    ><span
                      ><i class="el-icon-receiving"></i> {{ node.label }}</span
                    >

                    <span
                      v-if="!data.flag && data.Level > 2"
                      style="display: flex; align-items: center"
                    >
                      <el-tag
                        style="font-size: 10px; float: right"
                        type="warning"
                        >无模板</el-tag
                      >
                      <el-button
                        type="text"
                        style="margin-left: 10px; font-size: 10px"
                        @click="handleEdit(data)"
                        >去配置</el-button
                      >
                    </span>
                  </span>
                </span>
              </el-tree>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div class="drawer-footer">
        <el-button size="mini" @click="handleClose">取 消</el-button>
        <el-button
          size="mini"
          type="primary"
          @click="confirm"
          :loading="loading"
          :disabled="EquipmentClassificationIds.length === 0"
          >保存配置</el-button
        >
      </div>
    </el-drawer>
    <DesignPattern
      ref="DesignPattern"
      @save="getTreeData(true)"
    ></DesignPattern>
  </div>
</template>

<script>
import DesignPattern from '@/views/DesignPattern/DesignPattern.vue'
export default {
  props: {
    pId: { default: '', type: String, require: true },
  },
  components: { DesignPattern },
  data() {
    return {
      drawerVisible: false,
      loading: false,
      treeLoading: false,

      // 供应商信息
      supplierId: '',
      supplierName: '',
      supplierData: null,

      // 设备分类树数据
      TreeData: [],
      EquipmentClassificationIds: [],
      selectedCategoryNames: [], // 已选择的分类名称列表

      // 表单数据
      form: {},

      // 树属性配置
      defaultProps: {
        children: 'children',
        label: 'title',
      },
    }
  },
  methods: {
    //配置分类模板
    handleEdit(data) {
      console.log(data)
      if (
        this.$refs.DesignPattern &&
        this.$refs.DesignPattern.openDesignPattern
      ) {
        this.$refs.DesignPattern.openDesignPattern(
          this.pId,
          data.Id,
          data.title
        )
      } else {
        this.$notify.error('DesignPattern组件未加载完成')
      }
    },
    // 打开抽屉
    open(supplierData) {
      if (!supplierData) {
        this.$notify.error('供应商数据不能为空')
        return
      }

      this.supplierData = supplierData
      this.supplierId = supplierData.Id || supplierData.SupplierId || ''
      this.supplierName = supplierData.cVenName || '未知供应商'
      this.drawerVisible = true

      // 获取树数据和已配置的分类
      this.getTreeData()
      this.getSupplierConfig()
    },

    // 关闭抽屉
    handleClose() {
      this.drawerVisible = false
      this.resetData()
    },

    // 重置数据
    resetData() {
      this.supplierId = ''
      this.supplierName = ''
      this.supplierData = null
      this.TreeData = []
      this.EquipmentClassificationIds = []
      this.selectedCategoryNames = []
      this.form = {}
    },

    // 获取设备分类树数据
    getTreeData(isReset = false) {
      this.treeLoading = true
      if (!isReset) {
        if (window.sessionStorage.getItem('treeData')) {
          let resJson = {
            Data: JSON.parse(window.sessionStorage.getItem('treeData')) || [],
          }
          resJson.Data.Data.forEach((item) => {
            item.title = '全部'
          })
          // 过滤树数据
          this.TreeData = resJson.Data.Data
          this.treeLoading = false
          return
        }
      }
      // 优先从缓存获取

      // 从API获取
      this.$http
        .post(
          '/Base_ProjectWork/Base_Project/GetProjectDevice?ProjectId=' +
            this.pId
        )
        .then((resJson) => {
          this.treeLoading = false
          if (resJson.Success) {
            resJson.Data.Data.forEach((item) => {
              item.title = '全部'
            })
            this.TreeData = resJson.Data.Data
          } else {
            this.$notify.error(resJson.Msg || '获取设备分类失败')
          }
        })
        .catch(() => {
          this.treeLoading = false
          this.$notify.error('获取设备分类失败')
        })
    },

    // 获取供应商已配置的分类
    getSupplierConfig() {
      if (!this.supplierId) return

      this.$http
        .post('/Base_ProjectWork/Base_ProjectSupplier/GetTheData', {
          id: this.supplierId,
        })
        .then((res) => {
          if (res.Success && res.Data) {
            this.form = res.Data
            this.EquipmentClassificationIds = res.Data
              .EquipmentClassificationIds
              ? JSON.parse(res.Data.EquipmentClassificationIds)
              : []

            // 设置树的选中状态
            this.$nextTick(() => {
              if (this.$refs.tree && this.$refs.tree.setCheckedKeys) {
                this.$refs.tree.setCheckedKeys(this.EquipmentClassificationIds)
              }
            })
          }
        })
        .catch(() => {
          this.$notify.error('获取供应商配置失败')
        })
    },

    // 树节点选择变化处理
    handleCheckChange() {
      if (this.$refs.tree && this.$refs.tree.getCheckedKeys) {
        this.EquipmentClassificationIds = this.$refs.tree.getCheckedKeys()
      }
    },

    // 保存配置
    confirm() {
      if (this.EquipmentClassificationIds.length === 0) {
        this.$notify.warning('请至少选择一个设备分类')
        return
      }

      this.$confirm('是否确认保存设备分类配置?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.saveConfig()
      })
    },

    // 保存设备分类配置
    saveConfig() {
      this.loading = true

      this.$http
        .post('/Base_ProjectWork/Base_ProjectSupplier/SaveData', {
          ...this.form,
          ProjectId: this.pId,
          EquipmentClassificationIdList: this.EquipmentClassificationIds,
        })
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.$notify.success('设备分类配置保存成功')
            this.drawerVisible = false
            this.$emit('save')
          } else {
            this.$notify.error(res.Msg || '保存失败')
          }
        })
        .catch(() => {
          this.loading = false
          this.$notify.error('保存失败')
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.tree-class-container {
  padding: 20px;
  height: 100%;
}

.tree-content {
  height: calc(100% - 60px);

  .tree-tip {
    margin-bottom: 15px;
    padding: 10px;
    background-color: #e1f5fe;
    border-left: 4px solid #03a9f4;
    border-radius: 4px;
    color: #0277bd;
    font-size: 14px;

    i {
      margin-right: 8px;
    }
  }

  .device-tree {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 10px;
    max-height: 300px;
    overflow-y: auto;
    background-color: #fafafa;

    ::v-deep .el-tree-node__content {
      height: 32px;
      line-height: 32px;

      &:hover {
        background-color: #f0f9ff;
      }
    }

    ::v-deep .el-tree-node.is-checked > .el-tree-node__content {
      background-color: #e3f2fd;
      font-weight: 500;
    }
  }
}

.drawer-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  padding: 0 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  // background-color: #fff;
  // border-top: 1px solid #e8e8e8;
  // box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
}

::v-deep .el-drawer__header {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 20px;
}

::v-deep .el-form-item__label {
  font-weight: 500;
  color: #606266;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  i {
    margin-right: 6px;
  }
}
</style>
